import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setCollapseNotify, setShowTypeNotifications } from 'redux/actions/notificationActions';

import { ReactComponent as AngleArrowLeftIcon } from 'assets/icon-angle-left.svg';

import { CollapseClient } from '../styles';
import { Individual, Massive } from './styles';

const ContactPanel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showTypeNotifications } = useSelector((state) => state.notification);

  return (
    <div>
      <div className="d-flex justify-content-end">
        <CollapseClient onClick={() => dispatch(setCollapseNotify(true))}>
          <AngleArrowLeftIcon />
        </CollapseClient>
      </div>
      <hr />
      <Individual
        onClick={() => {
          dispatch(setShowTypeNotifications(false));
        }}
        showTypeNotifications={showTypeNotifications}
      >
        <span>{t('notifications_text_personals')}</span>
      </Individual>
      <Massive
        onClick={() => {
          dispatch(setShowTypeNotifications(true));
        }}
        showTypeNotifications={showTypeNotifications}
      >
        <span>{t('notifications_text_diffusion')}</span>
      </Massive>
    </div>
  );
};

ContactPanel.propTypes = {};

export default ContactPanel;
